var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIrarriba(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 18.09,
    viewBox: "0 0 15.5 18.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4080",
    "data-name": "Grupo 4080",
    transform: "translate(-1067 -1140.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-keyboard-arrow-up",
    "data-name": "Icon material-keyboard-arrow-up",
    d: "M10.821,21.571l5.929-5.916,5.929,5.916L24.5,19.75,16.75,12,9,19.75Z",
    transform: "translate(1058 1128.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-keyboard-arrow-up-2",
    "data-name": "Icon material-keyboard-arrow-up",
    d: "M10.821,21.571l5.929-5.916,5.929,5.916L24.5,19.75,16.75,12,9,19.75Z",
    transform: "translate(1058 1136.903)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrarriba);
export default __webpack_public_path__ + "static/media/Ir arriba.61a4fc02a75eebbb5c534f8539b90ddc.svg";
export { ForwardRef as ReactComponent };